import useAuth from '../hooks/useAuth';

const CheckRole = (funcion) => {
  const { user } = useAuth();

  const regex = new RegExp(funcion);
  return regex.test(user.role);
};

export default CheckRole;
